import React from 'react'
import Image from 'next/image'

import { Column, Layout, Row, Rows, Section } from '@/components/layout'
import FeaturesFooter from '@/components/sections/FeaturesFooter'
import FeaturePageHeader from '@/components/sections/FeaturePageHeader'
import accountantsHeroImg from '@/assets/accountants/accountants-hero.png'
import preventLossImg from '@/assets/accountants/icons/prevent-loss.png'
import reduceDataEntryImg from '@/assets/accountants/icons/reduce-data-entry.png'
import collaborateImg from '@/assets/accountants/icons/collaborate.png'
import multipleAccountsImg from '@/assets/accountants/multiple-accounts.png'
import supportImg from '@/assets/accountants/support.png'
import trophyImg from '@/assets/accountants/icons/trophy.png'
import handshakeImg from '@/assets/accountants/icons/handshake.png'
import megaphoneImg from '@/assets/accountants/icons/megaphone.png'

const pageId = 'accountants'

export default function Accountants() {
  return (
    <Layout.Content>
      <FeaturePageHeader
        description="Become a Neat Freak Partner to eliminate data entry and access your clients’ documents with a single sign-on."
        heroProps={{
          src: accountantsHeroImg,
          alt: '',
          maxWidth: 600,
          style: { height: 'auto' },
        }}
        subtitle="Simplify Your Workflow."
        title="Accountants"
        withPricingCta={false}
      />
      <Section>
        <Row>
          <Column center textCenter>
            <h2>Accountants & Their Clients Use Neat To:</h2>
          </Column>
        </Row>
        <Row>

          <Column alignCenter size={33} textCenter>
            <Image
              alt=""
              src={preventLossImg}
              style={{ height: 'auto' }}
            />
            <h3>Prevent Document Loss</h3>
            <p>Reduce document retrieval time and loss by storing your clients’ important financial documents in one secure location. Powerful keyword search and filtering capabilities mean you’ll never need to sift through boxes of receipts during tax time.</p>
          </Column>

          <Column alignCenter size={33} textCenter>
            <Image
              alt=""
              src={reduceDataEntryImg}
              style={{ height: 'auto' }}
            />
            <h3>Reduce Manual Data Entry</h3>
            <p>Your clients can easily snap, scan, import, or email financial documents into Neat where key information is extracted for quick reporting and integration with your accounting software.</p>
          </Column>

          <Column alignCenter size={33} textCenter>
            <Image
              alt=""
              src={collaborateImg}
              style={{ height: 'auto' }}
            />
            <h3>Simplify Collaboration</h3>
            <p>Share files and comment on documents without the need for large email attachments. Communicate with your clients seamlessly on any device.</p>
          </Column>

        </Row>
      </Section>
      <Section>
        <Row>
          <Column center size={50}>
            <Rows className="w-full">
              <h2 className="c-foreground">Streamline Your Firm</h2>
              <p>Neat’s expense management software for accountants and bookkeepers provides a hub for you to quickly access and take action upon all your clients’ important data.</p>
              <p>Offering multiple capture methods, including mobile, scanning, email, and import, Neat reduces document retrieval time from your clients and makes document storage more efficient. Neat’s patented parsing technology extracts the important data from those documents, allowing you to send it directly to your accounting software.</p>
            </Rows>
          </Column>
          <Column size={50}>
            <Image
              alt=""
              className="shadow-card"
              src={multipleAccountsImg}
              style={{ borderRadius: '32px', border: '1px solid #ffffff', height: 'auto' }}
            />
          </Column>
        </Row>
      </Section>

      <Section bgSecondary>
        <Row>
          <Column size={50}>
            <Image
              alt=""
              className="shadow-card"
              src={supportImg}
              style={{ borderRadius: '32px', border: '1px solid #ffffff', height: 'auto' }}
            />
          </Column>
          <Column center size={50}>
            <Rows className="w-full">
              <h2>Unlimited Support</h2>
              <p>When you start, we’ll connect you with your dedicated account manager. They will provide you with all the training needed to ensure you and your clients get the most out of Neat.</p>
              <p>You’ll also receive resources and product information via email — helpful tools to onboard your clients and show them how Neat can improve your joint workflows.</p>
            </Rows>
          </Column>
        </Row>
      </Section>
      <Section>
        <Row>
          <Column center textCenter>
            <h2>What Else Can Neat Partners Expect?</h2>
          </Column>
        </Row>
        <Row>

          <Column alignCenter size={33} textCenter>
            <Image
              alt="Trophy"
              src={trophyImg}
              style={{ height: 'auto' }}
            />
            <h3>Rewards & Incentives</h3>
            <p>Contests, giveaways, and prizes are available for Neat Partners.</p>
          </Column>

          <Column alignCenter size={33} textCenter>
            <Image
              alt="Handshake"
              src={handshakeImg}
              style={{ height: 'auto' }}
            />
            <h3>Exclusive Pricing</h3>
            <p>Create a pricing structure that works for your individual clients. Leverage wholesale billing or let your clients manage billing themselves.</p>
          </Column>

          <Column alignCenter size={33} textCenter>
            <Image
              alt="Megaphone"
              src={megaphoneImg}
              style={{ height: 'auto' }}
            />
            <h3>Broader Visibility</h3>
            <p>Get listed on Neat’s Find-an-Accountant directory and be featured in company marketing channels.</p>
          </Column>

        </Row>
      </Section>
      <FeaturesFooter />

    </Layout.Content>
  )
}

Accountants.layoutProps = {
  pageId,
}
